import { Typography, Box, styled, Stack } from "@mui/material";
import { basicColours, mainColours } from "@qubit/autoparts";

import { useClientConfig } from "~/hooks/useClientConfig";
import { PickingStateV2TotePick } from "~/types/api";

type Props = {
  allPicksForTote: PickingStateV2TotePick[];
};

const Container = styled(Stack)(
  ({
    ap_fusionPortScreenEnabled
  }: {
    ap_fusionPortScreenEnabled: boolean;
  }) => ({
    alignItems: "center",
    justifyContent: "center",
    alignSelf: ap_fusionPortScreenEnabled ? "unset" : "flex-end",
    height: ap_fusionPortScreenEnabled ? 240 : 252,
    minWidth: ap_fusionPortScreenEnabled ? 36 : 60,
    marginLeft: 10
  })
);

const ProgressBarTrack = styled(Box)(
  ({
    ap_fusionPortScreenEnabled
  }: {
    ap_fusionPortScreenEnabled: boolean;
  }) => ({
    display: "flex",
    position: "relative",
    width: 20,
    height: ap_fusionPortScreenEnabled ? 120 : 252,
    borderRadius: 10,
    backgroundColor: basicColours.mono[200]
  })
);

const ProgressBarFill = styled("span")<{ percent: number }>(({ percent }) => ({
  position: "absolute",
  bottom: 0,
  width: 20,
  height: `${percent}%`,
  borderRadius: 10,
  backgroundColor: mainColours.infographic[1],
  transition: "height 0.5s ease-in-out"
}));

const ToteProgressBarV2 = ({ allPicksForTote }: Props) => {
  const { ap_fusionPortScreenEnabled } = useClientConfig();

  const totalPicks = allPicksForTote.reduce(
    (acc, curr) =>
      curr.canceledReason || curr.canceledTimestamp ? acc : acc + curr.quantity,
    0
  );
  const completedPicks = allPicksForTote.reduce(
    (acc, curr) => (curr.completedTimestamp ? acc + curr.quantity : acc),
    0
  );
  const percentComplete =
    totalPicks === 0 ? 0 : (completedPicks / totalPicks) * 100;

  return (
    <Container ap_fusionPortScreenEnabled={ap_fusionPortScreenEnabled}>
      <ProgressBarTrack ap_fusionPortScreenEnabled={ap_fusionPortScreenEnabled}>
        <ProgressBarFill
          percent={percentComplete}
          aria-label="progress-bar-fill"
        />
      </ProgressBarTrack>

      <Typography
        variant="h6"
        color={basicColours.mono.black}
        fontWeight={500}
        sx={{ opacity: "60%" }}
      >
        {`${completedPicks} / ${totalPicks}`}
      </Typography>
    </Container>
  );
};

export default ToteProgressBarV2;
